import React from 'react';

function formatDisplay(value) {
    if (value === null || value === undefined || value === '') {
        return '—';
    }
    return value;
}

function buildMonthDetail(month, threshold) {
    const workDays = Number(month.work_days || 0);
    const factCount = Number(month.fact_count || 0);
    const thresholdNumber = Number(threshold || 0);
    const monthlyNorm = thresholdNumber > 0 ? Number((thresholdNumber * workDays).toFixed(2)) : 0;
    const deficitUnits = monthlyNorm > factCount ? Number((monthlyNorm - factCount).toFixed(2)) : 0;
    const deficitPerDay = thresholdNumber > 0 && Number(month.avg_per_day || 0) < thresholdNumber
        ? Number((thresholdNumber - Number(month.avg_per_day || 0)).toFixed(2))
        : 0;

    return {
        ...month,
        monthlyNorm,
        deficitUnits,
        deficitPerDay,
    };
}

export function WeakStatusButton({ row, onClick }) {
    if (!row?.label) {
        return null;
    }

    return (
        <button
            type="button"
            className={`shell-warningBadge ${row.status === 'persistent' ? 'shell-warningBadge--persistent' : ''} shell-warningBadgeButton`}
            onClick={() => onClick?.(row)}
        >
            {row.label}
        </button>
    );
}

export function WeakPerformanceHistoryModal({ row, onClose }) {
    if (!row) {
        return null;
    }

    const months = (row.recent_months || []).map((item) => buildMonthDetail(item, row.weak_threshold));
    const belowMonths = months.filter((item) => item.deficitPerDay > 0).length;
    const categoryLabel = row.category === 'modules' ? 'Модули' : 'Кассеты';

    return (
        <div className="shell-modalBackdrop" onClick={onClose}>
            <div className="shell-modalCard" onClick={(event) => event.stopPropagation()}>
                <div className="shell-modalHeader">
                    <div>
                        <span className="shell-sectionEyebrow">Контроль темпа</span>
                        <h3>{row.engineer}</h3>
                        <p className="shell-cardHint">
                            {row.location} • {categoryLabel}
                        </p>
                    </div>
                    <button type="button" className="shell-modalClose" onClick={onClose}>
                        Закрыть
                    </button>
                </div>

                <div className="shell-modalBody">
                    <div className="shell-pageSummary shell-pageSummary--twoWide shell-pageSummary--weakHistory">
                        <div className="shell-pageSummaryCard shell-pageSummaryCard--compact">
                            <span>Почему попал в стабильную просадку</span>
                            <strong>
                                Ниже порога {formatDisplay(row.weak_threshold)} / день уже {formatDisplay(row.trailing_weak_months)} мес.
                            </strong>
                        </div>
                        <div className="shell-pageSummaryCard shell-pageSummaryCard--compact">
                            <span>Месяцев ниже порога в истории</span>
                            <strong>{belowMonths}</strong>
                        </div>
                    </div>

                    <div className="shell-tableWrap shell-tableWrap--modal">
                        <table className="shell-table">
                            <thead>
                                <tr>
                                    <th>Месяц</th>
                                    <th>Раб. дней</th>
                                    <th>Факт</th>
                                    <th>Темп / день</th>
                                    <th>Порог</th>
                                    <th>Норма / мес.</th>
                                    <th>Недобор / день</th>
                                    <th>Недобор / мес.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {months.map((item) => {
                                    const isBelow = item.deficitPerDay > 0;
                                    return (
                                        <tr
                                            key={`${row.engineer}-${item.month_label}`}
                                            className={`shell-tableRow ${isBelow ? 'shell-tableRow--danger' : ''}`.trim()}
                                        >
                                            <td>{item.month_label}</td>
                                            <td>{formatDisplay(item.work_days)}</td>
                                            <td>{formatDisplay(item.fact_count)}</td>
                                            <td>{formatDisplay(item.avg_per_day)}</td>
                                            <td>{formatDisplay(row.weak_threshold)}</td>
                                            <td>{formatDisplay(item.monthlyNorm)}</td>
                                            <td>{item.deficitPerDay ? formatDisplay(item.deficitPerDay) : '—'}</td>
                                            <td>{item.deficitUnits ? formatDisplay(item.deficitUnits) : '—'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
